// extracted by mini-css-extract-plugin
export default {"container":"smallbox_container__kJH4F","iconWrapper":"smallbox_iconWrapper__YRGHN","text":"smallbox_text__emQBX"};